// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","442":"f651cd236536b0861ca655e6586c162b9e32d15e","821":"component---src-pages-portfolio-js"}[chunkId] + "-" + {"125":"1fc5f60d1a09b5e92a1d","293":"487aa7331b3af12649cf","442":"24f479fcded9e01eb0c7","821":"70486c1ee0e1f368a86b"}[chunkId] + ".js";
};